import { useIntl } from 'react-intl'
import { useState } from 'react'
import { LuxAutocomplete, LuxDialog } from '@lux/wardrobe-lib'
import { ProjectsService } from '@/app/services/ProjectsService'

const SelectProjectDialog = (props: {
    isOpen: boolean
    setIsOpen: (val: boolean) => void
    onSelectProject: (id: string) => void
    // setSelectedProject: (val: any) => void
}) => {
    const { setIsOpen, isOpen, onSelectProject } = props

    const intl = useIntl()

    const [projectSuggestions, setProjectSuggestions] = useState([])
    const [filterValue, setFilterValue] = useState([])
    const [isLoading, setIsLoading] = useState(false)

    const filterProjectSuggestions = (val: string) => {
        setIsLoading(true)
        ProjectsService.SearchProject(val, '', ['id', 'project_name'])
            .then((res) => {
                setProjectSuggestions(res.data.activities)
            })
            .finally(() => setIsLoading(false))
    }

    return (
        <LuxDialog
            visible={isOpen}
            onHide={() => setIsOpen(false)}
            title={intl.formatMessage({
                id: 'ph2.modals.dialog.album_project_selection',
                defaultMessage: 'Select a project',
            })}
            classes="select-project-dialog">
            <LuxAutocomplete
                value={filterValue}
                predictions={projectSuggestions}
                onSearchPredictions={filterProjectSuggestions}
                onPredictionSelected={(val: any) => onSelectProject(val.id)}
                onChangeCallback={setFilterValue}
                onClear={() => setFilterValue([])}
                additionalProps={{ panelClassName: 'ten-thousand-z-index' }}
                optionLabel={'project_name'}
                optionValue={'id'}
                minDigit={3}
                isLoading={isLoading}
            />
        </LuxDialog>
    )
}

export default SelectProjectDialog
